/**
 * This is useful for translations that require a dynamic value that
 * may change position in the string across different locale translations.
 * @param {*} string    - String template that using {{}} for string variables
 * @param {*} variables - Object with keys matching variable names to replace in string
 * @returns {string}    - Returns a string with variables added to a string template
 * @example
 * stringTemplate('My favorite color is {{color}}', {color: 'blue'})
 *   => 'My favorite color is blue'
 */
export const stringTemplate = (string, variables) => {
  const keys = Object.keys(variables);

  let newString = string;
  keys.forEach((key) => {
    newString = newString.replace(`{{${key}}}`, variables[key]);
  });

  return newString;
};

export default stringTemplate;
